import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { ApiUtils, MessagesApi, type DownloadAttachmentRequest } from '@shared/api';

interface UseDownloadMessageAttachmentStore {
  loading: boolean;
  error: string | null;
  downloadAttachment: (request: DownloadAttachmentRequest, filename?: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadMessageAttachmentStore = create<UseDownloadMessageAttachmentStore>((set) => ({
  loading: false,
  error: null,

  downloadAttachment: async (request, filename, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.downloadAttachment(request, signal);
      FileUtils.downloadFile(result, filename);
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, error: null }),
}));
